<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Surat Kirim</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button @click="getBorang" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th class="text-center" style="width: 20%">Nomor</th>
                            <th class="text-center" style="width: 20%">Validator</th>
                            <!-- <th style="width: 27%">Status</th> -->
                            <th style="width: 20%">Judul</th>
                            <th class="text-center" style="width: 10%">Tgl</th>
                            <th class="text-center" style="width: 7%">Status</th>
                            <th class="text-center" style="width: 18%"></th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                              <td class="text-center">{{index+1}}.</td>
                              <td>{{data.nomor}}</td>
                              <td>{{data.pemeriksa_gelar_depan}} {{data.pemeriksa_nama}},{{data.pemeriksa_gelar_belakang}}</td>
                              <!-- <td>{{data.status}}</td> -->
                              <td>{{data.judul}}</td>
                              <td class="text-center">{{timeSplit(data.tgl)}}</td>
                              <td class="text-center">
                                  <button type="button" class="btn btn-xs waves-effect" title="Lihat Detil Status" :style="cekStatus(data.status)">{{data.status}}</button>
                              </td>
                              <td class="text-center" >
                                <button class="btn bg-blue btn-xs waves-effect" title="Lihat Surat" id="edit_data" data-toggle="modal" data-target="#m_lihat_surat" @click="getData(data.id)">
                                    <i class="material-icons" >find_in_page</i>
                                </button>
                                &nbsp;
                                <button :disabled="cekEdit(data.status)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data" @click="getData(data.id)">
                                    <i class="material-icons" >create</i>
                                </button>
                                &nbsp;
                                <button :disabled="cekEdit(data.status)" @click="removeData(data.id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>   
                              </td>
                          </tr>
                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>
                        &nbsp;
                      <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>
                        &nbsp;
                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_tambah_data" role="dialog" data-keyboard="false" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-blue">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Jenis Surat</span>
                                                <select v-model="jenis" class="form-control" >
                                                    <option>Elektronik</option>
                                                    <option>Manual</option>
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Sifat Surat</span>
                                                <select v-model="sifat" class="form-control" >
                                                    <option>Biasa</option>
                                                    <option>Penting</option>
                                                    <option>Pribadi</option>
                                                    <option>Rahasia</option>
                                                    <option>Segera</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Type Surat/Template/Borang Acu</span>
                                                <select v-model="type" @change="pilih_borang" class="form-control" >
                                                    <option v-for="item in list_borang" :key="item.id" :value="item.id">{{item.type}}</option>
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Judul Surat</span>
                                                <input v-model="judul" type="text" class="form-control padding-input">
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Perihal</span>
                                                <input v-model="perihal" type="text" class="form-control padding-input">
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Nomor Surat</span>
                                                <input v-model="nomor" type="text" class="form-control padding-input">
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Pejabat PenandaTangan</span>
                                                <input type="text" id="penanda_tangan" class="form-control padding-input">
                                                <input type="text" id="penanda_tangan_nip" class="form-control padding-input" style="display:none">
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Pejabat Pemeriksa</span>
                                                <input type="text" id="pemeriksa" class="form-control padding-input">
                                                <input type="text" id="pemeriksa_nip" class="form-control padding-input" style="display:none">
                                            </div>
                                        </div>
                                        <br>
                                        <!-- <button class="btn btn-block" @click="sesuaikan_borang">PENYESUIAN BORANG</button> -->
                                        <div>
                                            <span class="h_title">Isi Surat</span>
                                            <textarea v-model="isi" id="editor1"></textarea>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Lampiran</span>
                                                <input @change="onFileSelected" type="file" id="fileku" class="form-control padding-input">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button @click="addData" type="button" class="btn btn-info waves-effect">KIRIM</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Jenis Surat</span>
                                                <select v-model="jenis" class="form-control" >
                                                    <option>Elektronik</option>
                                                    <option>Manual</option>
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Sifat Surat</span>
                                                <select v-model="sifat" class="form-control" >
                                                    <option>Biasa</option>
                                                    <option>Penting</option>
                                                    <option>Pribadi</option>
                                                    <option>Rahasia</option>
                                                    <option>Segera</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Type Surat/Template/Borang Acu</span>
                                                <select v-model="type" class="form-control" >
                                                    <option>Permohonan</option>
                                                    <option>Peraturan</option>
                                                    <option>Keputusan</option>
                                                    <option>Pedoman</option>
                                                    <option>Petunjuk Pelaksanaan</option>
                                                    <option>Instruksi</option>
                                                    <option>SOP</option>
                                                    <option>Surat Edaran</option>
                                                    <option>Surat Perintah</option>
                                                    <option>Surat Dinas</option>
                                                    <option>Memorandum</option>
                                                    <option>Nota Dinas</option>
                                                    <option>Surat Undangan</option>
                                                    <option>Surat Perjanjian</option>
                                                    <option>Surat Kuasa</option>
                                                    <option>Berita Acara</option>
                                                    <option>Surat Keterangan</option>
                                                    <option>Surat Pengantar</option>
                                                    <option>Pengumuman</option>
                                                    <option>Laporan</option>
                                                    <option>Telaahan Staf</option>
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Judul Surat</span>
                                                <input v-model="judul" type="text" class="form-control padding-input">
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Perihal</span>
                                                <input v-model="perihal" type="text" class="form-control padding-input">
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Nomor Surat</span>
                                                <input v-model="nomor" type="text" class="form-control padding-input">
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Pejabat PenandaTangan</span>
                                                <input v-model="penanda_tangan_nama" type="text" id="e_penanda_tangan" class="form-control padding-input">
                                                <input v-model="penanda_tangan_id" type="text" id="e_penanda_tangan_nip" class="form-control padding-input" style="display:none">
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Pejabat Pemeriksa</span>
                                                <input v-model="pemeriksa_nama" type="text" id="e_pemeriksa" class="form-control padding-input">
                                                <input v-model="pemeriksa_id" type="text" id="e_pemeriksa_nip" class="form-control padding-input" style="display:none">
                                            </div>
                                        </div>
                                        <br>
                                        <div>
                                            <span class="h_title">Isi Surat</span>
                                            <textarea v-model="isi" id="editor2"></textarea>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Lampiran</span>
                                                <input @change="onFileSelected" type="file" id="fileku" class="form-control padding-input">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button @click="editData()" type="button" class="btn btn-success waves-effect">RUBAH</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_lihat_surat" role="dialog">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-blue">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>
                                    <div class="modal-body">

                                        <div class="table-responsive">
                                            <table class="h_isitable" style="width: 100%">
                                                <tr>
                                                    <td style="width: 19%; padding-left:2%">Konseptor</td>
                                                    <td style="width: 1%; padding-left:2%">:</td>
                                                    <td style="width: 80%; padding-left:2%">Hikmah Langgahi Tama</td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 19%; padding-left:2%">Pemeriksa</td>
                                                    <td style="width: 1%; padding-left:2%">:</td>
                                                    <td style="width: 80%; padding-left:2%">
                                                        {{pemeriksa_gelar_depan}} {{pemeriksa_nama}} {{pemeriksa_gelar_belakang}}
                                                        &nbsp;
                                                        <span v-if="status != 'proses'">
                                                            ({{timeSplit(tgl_validasi)}})

                                                            <i  v-if="status == 'diterima'" class="material-icons" style="color:green">check</i>
                                                            <i  v-if="status == 'dikembalikan'" class="material-icons" style="color:red">clear</i>
                                                        </span>
                                                        
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 19%; padding-left:2%">Penanda Tangan</td>
                                                    <td style="width: 1%; padding-left:2%">:</td>
                                                    <td style="width: 80%; padding-left:2%">
                                                        {{penanda_tangan_gelar_depan}} {{penanda_tangan_nama}} {{penanda_tangan_gelar_belakang}}
                                                         &nbsp;
                                                        <span v-if="status_ttd">
                                                            ({{timeSplit(tgl_validasi)}})
                                                            <i class="material-icons" style="color:green">check</i>
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 19%; padding-left:2%">Status</td>
                                                    <td style="width: 1%; padding-left:2%">:</td>
                                                    <td style="width: 80%; padding-left:2%">{{keterangan}}</td>
                                                </tr>
                                                
                                            </table>
                                            <hr>
                                            <span>
                                                <div v-html="isi"></div>
                                            </span>
                                            <hr>
                                            <button type="button" class="btn btn-default" data-toggle="modal" data-target="#m_lampiran_surat">
                                                LAMPIRAN
                                                <i class="material-icons">attachment</i>
                                            </button>
                                        </div>



                                    </div>
                                    <div class="modal-footer">
                                        <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LAMPIRAN SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_lampiran_surat" role="dialog">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-blue">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">LAMPIRAN SURAT</h4>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row text-center">
                                            <embed v-bind:src="file_tampil" width="100%" height="2100px" />
                                            <!-- <iframe v-bind:src="'https://docs.google.com/gview?url='+file_tampil+'&embedded=true'" style="width: 100%;height: 2100px;border: none;" frameborder="0"></iframe> -->
                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LAMPIRAN SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>
    // var aa = CKEDITOR.instances.editor1.getData()
    const ADD_URL = URL_APP+'api/v1/office_surat_kirim/';
    const UNIT_URL = URL_APP+'api/v1/simpeg_unit_kerja/';
    const BORANG_URL = URL_APP+'api/v1/office_borang_acu/';
    const FILE_LOAD = URL_APP+'uploads/';


    export default {
    name: "monev_kabupaten",
    data() {
        return {
            id : '',
            isi : '',
            jenis : 'Elektronik',
            judul : '',
            keterangan : '',
            status : '',
            konseptor : '',

            lampiran : '',
            lampiran_type : '',
            nomor : '',
            pemeriksa : '',
            pemeriksa_gelar_belakang : '',
            pemeriksa_gelar_depan : '',
            pemeriksa_gol : '',
            pemeriksa_id : '',
            pemeriksa_jabatan : '',
            pemeriksa_nama : '',

            penanda_tangan : '',
            penanda_tangan_gelar_belakang : '',
            penanda_tangan_gelar_depan : '',
            penanda_tangan_gol : '',
            penanda_tangan_id : '',
            penanda_tangan_jabatan : '',
            penanda_tangan_nama : '',
            tgl : '',
            tgl_validasi : '',
            tgl_ttd : '',
            tgl_agenda : '',

            perihal : '',
            sifat : 'Biasa',
            status : '',
            status_ttd : 0,
            tgl : '',
            type : 'Permohonan',
            unit_kerja : '',
            unit_unit_kerja : '',

            fileku : null,
            file_tampil : '',

            list_borang: [],
            list_data: [],
            page_first: 1,
            page_last: 0,
            cari_value: ""
        };
    },

    // =============================================================== METHODS =========================================================================
    methods : {
        onFileSelected : function(event){
            this.fileku = event.target.files[0];
        },
        getView: function() {
            fetch(ADD_URL + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value
                })
            })
                .then(res => res.json())
                .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                // console.log(res_data);
            });
        },
        addData : function(){
            var formData = new FormData();
            var fileField = document.querySelector("input[type='file']");
            var profile = JSON.parse(localStorage.profile);

            formData.append('unit_kerja', profile.profile.unit_kerja);
            formData.append('user_id', profile.profile.user_id);
            formData.append('jenis', this.jenis);
            formData.append('sifat', this.sifat);
            formData.append('type', this.type);
            formData.append('judul', this.judul);
            formData.append('perihal', this.perihal);
            formData.append('nomor', this.nomor);
            formData.append('konseptor', profile.profile.user_id);
            formData.append('penanda_tangan', document.getElementById('penanda_tangan_nip').value);
            formData.append('pemeriksa', document.getElementById('pemeriksa_nip').value);
            formData.append('isi', CKEDITOR.instances.editor1.getData());
            formData.append('file', this.fileku);
           
            fetch (ADD_URL+'surat_kirim', {
              method : 'POST',
              headers : {
                authorization: "kikensbatara " + localStorage.token
              },
              body : formData
            }).then((res_data)=>{
                this.alertku("success", "sukses menambah data");
                this.getView();
                this.fileku = null;
            });
        },
        editData : function(){
            var formData = new FormData();
            var profile = JSON.parse(localStorage.profile);

            formData.append('id', this.id);
            formData.append('jenis', this.jenis);
            formData.append('sifat', this.sifat);
            formData.append('type', this.type);

            formData.append('judul', this.judul);
            formData.append('perihal', this.perihal);
            formData.append('nomor', this.nomor);
            formData.append('konseptor', profile.profile.user_id);
            formData.append('penanda_tangan', document.getElementById('e_penanda_tangan_nip').value);
            formData.append('pemeriksa', document.getElementById('e_pemeriksa_nip').value);
            formData.append('isi',CKEDITOR.instances.editor2.getData());
            if(this.fileku != null){formData.append('file',this.fileku)};

            fetch(ADD_URL+'editData', {
                method : 'POST',
                headers : {
                    authorization : 'kikensbatara '+ localStorage.token
                },
                body : formData
            }).then((res_data)=>{
                this.fileku = null;
                this.getView();
                this.alertku("success", "Sukses merubah data");
            })
        },
        getData : function(idnya){
            fetch(ADD_URL + "getData",{
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    id: idnya,
                })
            })
            .then(res => res.json())
            .then (data => {
                var dt = data[0]
                
                this.id = dt.id;
                this.file_tampil = FILE_LOAD+''+dt.lampiran,
                this.isi = dt.isi;
                this.status = dt.status;
                this.status_ttd = dt.status_ttd;
                CKEDITOR.instances.editor2.setData(dt.isi);
                this.jenis = dt.jenis;
                this.judul = dt.judul;
                this.keterangan = dt.keterangan;
                this.konseptor = dt.konseptor;
                this.lampiran = dt.lampiran;
                this.lampiran_type = dt.lampiran_type;
                this.nomor = dt.nomor;
                this.pemeriksa = dt.pemeriksa;
                this.pemeriksa_gelar_belakang = dt.pemeriksa_gelar_belakang;
                this.pemeriksa_gelar_depan = dt.pemeriksa_gelar_depan;
                this.pemeriksa_gol = dt.pemeriksa_gol;
                this.pemeriksa_id = dt.pemeriksa_id;
                this.pemeriksa_jabatan = dt.pemeriksa_jabatan;
                this.pemeriksa_nama = dt.pemeriksa_nama;
                this.penanda_tangan = dt.penanda_tangan;
                this.penanda_tangan_gelar_belakang = dt.penanda_tangan_gelar_belakang;
                this.penanda_tangan_gelar_depan = dt.penanda_tangan_gelar_depan;
                this.penanda_tangan_gol = dt.penanda_tangan_gol;
                this.penanda_tangan_id = dt.penanda_tangan_id;
                this.penanda_tangan_jabatan = dt.penanda_tangan_jabatan;
                this.penanda_tangan_nama = dt.penanda_tangan_nama;
                this.perihal = dt.perihal;
                this.sifat = dt.sifat;
                this.status = dt.status;
                this.tgl = dt.tgl;


                this.tgl_validasi = dt.tgl_validasi;
                this.tgl_ttd = dt.tgl_ttd;
                this.tgl_agenda = dt.tgl_agenda;

                this.type = dt.type;
                this.unit_kerja = dt.unit_kerja;
                this.unit_unit_kerja = dt.unit_unit_kerja;
                // ==========================================
                this.getBorang();
            })
        },
        removeData : function(idnya){
            fetch(ADD_URL + "removeData",{
                method : 'POST',
                headers : {
                   "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    id : idnya
                })
            }).then((res_data) => {
                this.alertku("success", "sukses menghapus data");
                this.getView();
                this.fileku = null;
            });
        },
        cekStatus : function(data){
            if(data == 'diterima'){
                return {background : '#e4ffc4'}
            }
            else if (data == 'dikembalikan') {
                return {background : '#ffcece'}
            }
        },
        cekEdit : function(data){
            if(data == 'diterima'){
                return true;
            }
            else {
                return false;
            }
        },
        timeSplit : function(date){
            var time = date.split('T');
            var tgl = time[0].split('-');
            return tgl[2]+"-"+tgl[1]+"-"+tgl[0]
        },
        getBorang : function(){
            fetch(BORANG_URL, {
                method: "GET",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
            })
                .then(res => res.json())
                .then(res_data => {
                this.list_borang = res_data;
                // console.log(res_data);
            });
        },
        pilih_borang : function(){
            // alert(this.type);
            fetch(BORANG_URL+"getOne", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    id : this.type,
                }),
            })
                .then(res => res.json())
                .then(res_data => {
                // this.list_borang = res_data;
                // console.log(res_data[0].borang);
                CKEDITOR.instances.editor1.setData(res_data[0].borang);
                CKEDITOR.instances.editor2.setData(res_data[0].borang);
            });

            
        },
        sesuaikan_borang : function(){
            // var id_nomor = document.getElementById('id_nomor');
            // id_nomor.innerHTML += this.nomor;

            document.getElementById("id_nomor").html("this text will be added to div");
        },
        autocompleted1 : function(unit_Kerja){
            fetch(URL_APP+'api/v1/simpeg_biodata/getView', {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({ 
                    unit_kerja: unit_Kerja,
                }),
                
            })
                .then(res => res.json())
                .then(res_data => {
                
                horsey(document.querySelector('#pemeriksa'), {
                    source: [{ list: res_data }],
                    getText: 'nama',
                    getValue: 'nama',
                    renderItem: function (li, suggestion) {
                    li.innerHTML = `<span class="body_auto">`+suggestion.nama+`</span><br>
                    <span class="head_auto">`+suggestion.nip+`</span><br>`
                    },
                    predictNextSearch(info) {
                    document.getElementById('pemeriksa_nip').value = info.selection.id;
                    },
                    limit: 10
                });

                horsey(document.querySelector('#e_pemeriksa'), {
                    source: [{ list: res_data }],
                    getText: 'nama',
                    getValue: 'nama',
                    renderItem: function (li, suggestion) {
                    li.innerHTML = `<span class="body_auto">`+suggestion.nama+`</span><br>
                    <span class="head_auto">`+suggestion.nip+`</span><br>`
                    },
                    predictNextSearch(info) {
                    document.getElementById('e_pemeriksa_nip').value= info.selection.id ;
                    },
                    limit: 10
                });

                horsey(document.querySelector('#penanda_tangan'), {
                    source: [{ list: res_data }],
                    getText: 'nama',
                    getValue: 'nama',
                    renderItem: function (li, suggestion) {
                    li.innerHTML = `<span class="body_auto">`+suggestion.nama+`</span><br>
                    <span class="head_auto">`+suggestion.nip+`</span><br>`
                    },
                    predictNextSearch(info) {
                    document.getElementById('penanda_tangan_nip').value = info.selection.id;
                    },
                    limit: 10
                });

                horsey(document.querySelector('#e_penanda_tangan_nip'), {
                    source: [{ list: res_data }],
                    getText: 'nama',
                    getValue: 'nama',
                    renderItem: function (li, suggestion) {
                    li.innerHTML = `<span class="body_auto">`+suggestion.nama+`</span><br>
                    <span class="head_auto">`+suggestion.nip+`</span><br>`
                    },
                    predictNextSearch(info) {
                    document.getElementById('e_penanda_tangan_nip_nip').value= info.selection.id ;
                    },
                    limit: 10
                });

            });

        },
        // ================== PAGINASI ====================
            alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
            },

            btn_prev: function() {
            if (this.page_first > 1) {
                this.page_first--;
            } else {
                this.page_first = 1;
            }
            this.getView();
            },

            btn_next: function() {
            if (this.page_first >= this.page_last) {
                this.page_first == this.page_last;
            } else {
                this.page_first++;
            }
                this.getView();
            },

            cari_data: function() {
                this.getView();
            },
        // ================== PAGINASI ====================
    },
    // =============================================================== METHODS =========================================================================

    mounted() {
        localStorage.sidemenu = 'office';
        this.getView();
        CKEDITOR.replace( 'editor1',{
            // width: 793.700787,
            height: 1122.519685,
        });

        CKEDITOR.replace( 'editor2',{
            // width: 793.700787,
            height: 1122.519685,
        });

        $(".pilih_unit").click(function(){
            // $("p").toggle();
            alert('bjquery')
        });
       
        var profile = JSON.parse(localStorage.profile);
        var unit_kerja = profile.profile.unit_kerja;  
        this.autocompleted1(unit_kerja);
       


    },

    };
</script>
